export const FAQ =
  "https://support.roadbotics.com/hc/en-us/categories/360002554151-RoadWay";
